import styled from 'styled-components';

const PageTitle = styled.h1`
    color: rgba(0, 0, 0, 0.8);
    font-size: 2em;
    font-weight: normal;
    margin: 0;
    padding: 0;
`;

export default PageTitle;
